<template>
  <App />
</template>

<script>
import App from "@/components/apps/App.vue";
import { mapActions } from 'vuex';

export default {
  name: "AppView",

  components: {
    App,
  },

  methods: {
    ...mapActions('app', ['appsList']),
  },
  mounted() {
    this.appsList();
  },
};
</script>
